module.exports = __webpack_public_path__ + "img/png_wgzl_4@2x.45fcfa70.png";